import { Entity } from '@backstage/catalog-model';

/** The name the catalog table shows (and sorts by) for an entity. */
export const displayedName = (entity: Entity) =>
  entity.metadata.title ?? entity.metadata.name;
